import DealsHeader from './Deals/DealsHeader';
import Header from './Header';
import InvoicesHeader from './Invoices/InvoicesHeader';

export default Header;
export { DealsHeader, InvoicesHeader };
